export const getSettingId = (item) => item?.SettingId ?? item?.settingId;
